import EfIcon from '@elem/ui/ef-icon';
import EfImg from '@elem/ui/ef-img';
import { useLang } from '@/i18n';

const ICON1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M12.6667 20H7.33337L12.6667 14" stroke="#757575" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M26 20C26 11.3388 19.3291 2.66663 12.6666 2.66663V20H26Z" stroke="#757575" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M21.7675 27.7177L28 24H4L5.33333 28H20.7429C21.1037 28 21.4577 27.9025 21.7675 27.7177Z"
            stroke="#757575"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M12.6666 20V24" stroke="#757575" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const ICON2 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <g clipPath="url(#clip0_3937_14682)">
            <path
                d="M29 23.5L29 7.5C29 6.67157 28.3284 6 27.5 6L4.5 6C3.67157 6 3 6.67157 3 7.5L3 23.5C3 24.3284 3.67157 25 4.5 25L27.5 25C28.3284 25 29 24.3284 29 23.5Z"
                stroke="#707070"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18 21L18 10C18 9.44772 17.5523 9 17 9L7 9C6.44772 9 6 9.44771 6 10L6 21C6 21.5523 6.44772 22 7 22L17 22C17.5523 22 18 21.5523 18 21Z"
                stroke="#707070"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <line x1="8" y1="13.25" x2="16" y2="13.25" stroke="#707070" strokeWidth="1.5" />
            <line x1="8" y1="17.25" x2="11" y2="17.25" stroke="#707070" strokeWidth="1.5" />
            <circle cx="23.5" cy="12.5" r="1.5" fill="#707070" />
            <path
                d="M24 9.5C24 9.77614 23.7761 10 23.5 10C23.2239 10 23 9.77614 23 9.5C23 9.22386 23.2239 9 23.5 9C23.7761 9 24 9.22386 24 9.5Z"
                fill="#707070"
            />
            <path
                d="M20.5 12C20.7761 12 21 12.2239 21 12.5C21 12.7761 20.7761 13 20.5 13C20.2239 13 20 12.7761 20 12.5C20 12.2239 20.2239 12 20.5 12Z"
                fill="#707070"
            />
            <path
                d="M24 15.5C24 15.7761 23.7761 16 23.5 16C23.2239 16 23 15.7761 23 15.5C23 15.2239 23.2239 15 23.5 15C23.7761 15 24 15.2239 24 15.5Z"
                fill="#707070"
            />
            <path
                d="M26.5 12C26.7761 12 27 12.2239 27 12.5C27 12.7761 26.7761 13 26.5 13C26.2239 13 26 12.7761 26 12.5C26 12.2239 26.2239 12 26.5 12Z"
                fill="#707070"
            />
        </g>
        <defs>
            <clipPath id="clip0_3937_14682">
                <rect width="32" height="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default function TheComp() {
    const { t } = useLang('theProduct.TabA');

    return (
        <div className="ef-container TabA-card card-a">
            <div className="TabA-card-l">
                <EfImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1725851346748/pc_taba_1.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1725851345379/m_taba_1.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1725851345379/m_taba_1.jpg"
                />
            </div>
            <div className="TabA-card-r">
                <div className="TabA-card-r-in">
                    <div className="TabA-card-title">{t('a_title')}</div>
                    <div className="TabA-card-list">
                        <div className="TabA-card-item">
                            <div className="TabA-card-item-icon">
                                <ICON1 />
                            </div>
                            <div className="TabA-card-item-text1">
                                5<span className="unit">{t('unit')}</span>
                            </div>
                            <div className="TabA-card-item-text2">{t('a_item1_t2')}</div>
                        </div>
                        <div className="TabA-card-item">
                            <div className="TabA-card-item-icon">
                                <ICON2 />
                            </div>
                            <div className="TabA-card-item-text1">
                                5<span className="unit">{t('unit')}</span>
                            </div>
                            <div className="TabA-card-item-text2">{t('a_item2_t2')}</div>
                        </div>
                    </div>
                    <div className="TabA-card-bg">
                        <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1726639175827/TM.png" />
                    </div>
                    <div className="TabA-card-tips">{t('a_text2')}</div>
                </div>
            </div>
        </div>
    );
}
